export const singleDoubleClicksMixin = {
  data() {
    return {
      clickCount: 0,
      clickTimer: null,
      delay: 500,
    };
  },

  methods: {
    /**
     * Handle single and double click event emision
     */
    handleSingleAndDoubleClick(event, doubleClickCallback, singleClickCallback) {
      this.clickCount++;

      if (this.clickCount === 1 && singleClickCallback) {
        this.clickTimer = setTimeout(() => {
          this.clickCount = 0;
          singleClickCallback(event);
        }, this.delay);
      } else if (this.clickCount === 2) {
        clearTimeout(this.clickTimer);
        this.clickCount = 0;
        doubleClickCallback(event);
      }
    },
  },
};
